import { RootState } from '../store';

export const selectActivePage = (state: RootState) => state.page.activePage;

export const selectActivePrompt = (state: RootState) => state.page.activeBlock;

export const selectAddedHashtag = (state: RootState) => state.page.addedHashtag;

export const selectCropMode = (state: RootState) => state.page.cropMode;

export const selectActiveEditorMode = (state: RootState) => state.page.activeEditorMode;

export const selectActiveSettingsSlider = (state: RootState) => state.page.activeSettingsSlider;

export const selectPricingModal = (state: RootState) => state.page.pricingModal;
